//const backendDomain = "http://192.168.1.190/ghraisoni_adminstration";

const backendDomain = "https://billing.ghraisoni.com/api";



// src/api/SummaryApi.js

const SummaryApi = {


ReciptImages:{
      url: `${backendDomain}/student/receipts/`,
    method: "POST",
},


downloadfiles:{
       url: `${backendDomain}/student/download.php`,
    method: "GET",
},


    studentRegistration: {
    url: `${backendDomain}/student/student_create.php`,
    method: "POST",
  },

  getstudentByid: {
    url: `${backendDomain}/student/student_retrieve.php`,
    method: "POST",
  },
  

updatestudentbyid:{
      url: `${backendDomain}/student/student_update.php`,
    method: "POST",
},


  studentbillingCreate: {
    url: `${backendDomain}/student_billing/student_billing_create.php`,
    method: "POST",
  },

  getstudentAll: {
    url: `${backendDomain}/student/student_retrieve.php`,
    method: "GET",
  },

  getallstudentpayments: {
    url: `${backendDomain}/student_payment/payment_retrieve.php`,
    method: "GET",
  },




createpaymentstudent:{
 url: `${backendDomain}/student/student_update.php`,
    method: "POST",
 
}
,

consultancyname:{
   url: `${backendDomain}/admin/consultant_retrieve.php`,
    method: "GET",
},


getstudentsbyconsultant:{
   url: `${backendDomain}/student/student_retrieve.php`,
    method: "PUT",
},





adminlogin: {
    url: `${backendDomain}/admin/admin_login.php`,
    method: "POST",
  },
























  getstudentAllBilling: {
    url: `${backendDomain}/student_billing/student_billing_retrieve.php`,
    method: "GET",
  },


getDashboardSummary: {
    url: `${backendDomain}/dashboard/counts.php`,
    method: "GET",
  },

getDashboardSummaryAdmin: {
    url: `${backendDomain}/dashboard/counts.php`,
    method: "GET",
  },


studentsreports:{
    url: `${backendDomain}/student_billing/billing_students_retrieve.php`,
    method: "GET",
},

studentsreportsbyid:{
    url: `${backendDomain}/student_billing/billing_students_retrieve.php`,
    method: "POST",
}



//create consultant
,
createConsultant: {
    url: `${backendDomain}/admin/admin_create.php`,
    method: "POST", },



UpdateConsultant: {
    url: `${backendDomain}/admin/admin_update.php`,
    method: "POST", },



Getallconsultants: {
    url: `${backendDomain}/admin/admin_retrieve.php`,
    method: "GET", },


GetconsultantByid: {
    url: `${backendDomain}/admin/admin_retrieve.php`,
    method: "POST", },


  getstudentByConsultantid: {
    url: `${backendDomain}/student_billing/billing_students_retrieve.php`,
    method: "PUT",
  },


  getRegisteredstudentsByConsultantid: {
    url: `${backendDomain}/student/student_retrieve.php`,
    method: "PUT",
  },



  getstudentAllBillingByconsultantid: {
    url: `${backendDomain}/student_billing/student_billing_admin_retrieve.php`,
    method: "POST",
  },





  getTodayRegistrations: {
    url: `${backendDomain}/student/today_admin_retrieve.php`,
    method: "GET",
  },


  
  getTotalregistrationsbyconsultantid: {
    url: `${backendDomain}/student/student_billing_retrieve.php`,
    method: "POST",
  },




paymentcompletedupdate:{
    url: `${backendDomain}/student_payment/payment_update.php`,
    method: "POST",
},















getallstudentsbydatefilter:{
  url: `${backendDomain}/student/student_admin_retrieve.php`,
    method: "PUT",
},


paymentdonemailsend:{
  url: `${backendDomain}/mail/sendmail.php`,
    method: "POST",
},



dashboardcounts:{
    url: `${backendDomain}/dashboard/counts.php`,
    method: "GET",
},


studentadmissionupdate:{
 url: `${backendDomain}/student/student_admission_update.php`,
    method: "POST",

},





// check list related apis 

getchecklist:{
 url: `${backendDomain}/document_checklist/checklist_retrieve.php`,
    method: "PUT",


},

addchecklist:{
 url: `${backendDomain}/document_checklist/checklist_create.php`,
    method: "POST",


},

updatechecklist:{
 url: `${backendDomain}/document_checklist/checklist_update.php`,
    method: "POST",


},

// payment in check list page 


createonboardingpayment:{
 url: `${backendDomain}/onboard_fee/payment_create.php`,
    method: "POST",


},





downloadownloadrecipt:{
       url: `${backendDomain}/onboard_fee/download.php`,
    method: "GET",
},




getonboardpaymentdetails:{



 url: `${backendDomain}/onboard_fee/payment_retrieve.php`,
    method: "PUT",

},




updatereportingstudents:{
 url: `${backendDomain}/student/student_update.php`,
    method: "PUT",
}



};

export default SummaryApi;